import axios from '@/axios.js'

export default {
    getMapboxAccounts: async (extraParams, page) => {
        const response = await axios.adminapi.get(`v4/mapbox-accounts`,{
            params: {
                ...extraParams,
                ...(page ? { page: page } : {})
            }
        })
        return response.data.object
    },

    getMapboxAccount: async (uuid) => {
        const response = await axios.adminapi.get(`v4/mapbox-accounts/${uuid}`)
        return response.data.object
    },

    createMapboxAccount: async (uuid, data) => {
        const response = await axios.adminapi.post(`v4/mapbox-accounts/${uuid}`, data)
        return response.data.object
    },

    updateMapboxAccount: async (uuid, data) => {
        const response = await axios.adminapi.patch(`v4/mapbox-accounts/${uuid}`, data)
        return response.data.object
    },

    deleteMapboxAccount: async (uuid) => {
        const response = await axios.adminapi.delete(`v4/mapbox-accounts/${uuid}`)
        return response.data.object
    },
}
